import { TrackingConfigStoreProps, TrackingEventConfigData } from 'root/global-wrappers/types/analytics';

const configStore: TrackingConfigStoreProps = {};

export const addTrackingConfig = (page: string, config: TrackingEventConfigData) => {
  configStore[page] = config;
};

export const getTrackingConfig = (page: string) => configStore[page];
